// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6843ae66] .modal-header{display:flex;align-items:flex-start;justify-content:space-between;padding:1rem 1rem 0 1rem;border-bottom:none!important}[data-v-6843ae66] .modal-body{position:relative;flex:1 1 auto;padding:0 1rem 0 1rem}[data-v-6843ae66] .modal-footer{display:flex;align-items:center;justify-content:flex-start!important;padding:0 1rem 1rem 1rem;border:none!important}[data-v-6843ae66] .modal-backdrop{background-color:rgba(0,0,0,.4)!important}", ""]);
// Exports
module.exports = exports;
